import { useEffect } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";
import { Star } from "./Logo";
import { useLang } from "@/i18n/LanguageContext";

const B2B_IDX = [7, 8, 9, 10, 11, 12, 13, 28];

export default function FAQ({ variant = "b2c" }) {
  const { t } = useLang();
  const items = t.faq.items.filter((_, i) => (variant === "b2b" ? B2B_IDX.includes(i) : !B2B_IDX.includes(i)));
  const title = variant === "b2b" ? t.b2bPage.faqTitle : t.faq.title;
  const ldId = `ld-faq-${variant}`;

  useEffect(() => {
    document.getElementById(ldId)?.remove();
    const ld = document.createElement("script");
    ld.type = "application/ld+json";
    ld.id = ldId;
    ld.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    });
    document.head.appendChild(ld);
    return () => document.getElementById(ldId)?.remove();
  }, [t, variant]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section id="faq" className="mx-auto max-w-4xl px-5 sm:px-8 py-24 sm:py-36" data-testid="faq-section">
      <Reveal className="text-center">
        <p className="flex items-center justify-center gap-2 text-xs uppercase font-medium" style={{ color: "var(--camel)", letterSpacing: "0.16em" }}>
          <Star size={11} /> {t.faq.kicker}
        </p>
        <h2 className="mt-5 font-serif-display text-4xl sm:text-5xl font-semibold leading-tight" data-testid="faq-title">
          {title}
        </h2>
      </Reveal>

      <Reveal delay={0.15} className="mt-14">
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border px-6 data-[state=open]:shadow-sm"
              style={{ borderColor: "var(--line)", background: "var(--surface-secondary)" }}
              data-testid={`faq-item-${i + 1}`}
            >
              <AccordionTrigger className="py-5 text-left font-serif-display text-lg sm:text-xl font-semibold hover:no-underline [&>svg]:text-[var(--camel)]">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-sm sm:text-base leading-relaxed" style={{ color: "var(--muted-warm)" }}>
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
